import React from 'react';
import type { Event, EventHeroScopedProps } from '../../../types/index';
import './EventHero.scss';
import { HeroCarousel } from './HeroCarousel';

export type EventHeroProps = {
    eventName: Event['name'];
} & EventHeroScopedProps &
    Pick<Event, 'hasCroppedLogo'>;

export const EventHero = ({
    mainBodyBackground: { croppedLogoUrl50 },
    items = [],
    eventName,
    featuredVideo,
}: EventHeroProps) => {
    const shouldShowEventHero = items.length > 0 || featuredVideo;
    const backgroundImage =
        croppedLogoUrl50 || featuredVideo?.thumbnail?.small?.url;
    return (
        <>
            {shouldShowEventHero && (
                <div className="event-hero-wrapper" data-testid="event-hero">
                    <div className="event-hero">
                        <div
                            className="event-hero__background"
                            style={{
                                backgroundImage: `url("${backgroundImage}")`,
                            }}
                        />
                        <HeroCarousel
                            eventName={eventName}
                            items={items}
                            featuredVideo={featuredVideo}
                        />
                    </div>
                </div>
            )}
        </>
    );
};
